export default {
  color: "#e84910",
  background: "#F9F9F7",
  base_url: 'https://structurea.be/',
  blue_structurea: "#203478",
  white_color: "#fff",
  blue_ligth: "#2B74A7"
};
